import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_DRIVER, Driver } from 'src/utils/interfaces/interfaces';
import moment from 'moment';
import { Button } from "@heroui/react";
import i18n from 'src/i18n';
// import { DRIVER_driver_TYPE } from "src/constants/driver/driverConstants";
export interface IMemberListProps {
  driver: Driver;
  onClose: Function;
  onAction: Function;
}
export function DriverList({
  driver = DEFAULT_DRIVER,
  onAction = () => {},
  onClose = () => {},
}: IMemberListProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  const { t } = useTranslation();

  return (
    <div
      className="bg-white/[0.04] grid grid-cols-12 gap-5 px-7 py-8 border-b-4 border-primary"
      key={driver._id}
    >
      <div className="col-span-3 grid grid-cols-7 gap-5">
        <img
          src="/assets/icons/vendors/avatar.svg"
          alt="avatar"
          className="inline col-span-2 shadow-xl rounded-full"
        />
        <div className="col-span-5  ">
          <p className="text-sm text-blue/[0.5]">{t('user.name')}</p>
          <div>
            <p className="text-sm">{`${driver.firstName} ${driver.lastName}`}</p>
          </div>
        </div>
      </div>
      <div className="   col-span-2">
        <p className="text-sm text-blue/[0.5]">{t('user.contact_number')}</p>
        <div>
          <p className="text-sm">{driver.phone}</p>
        </div>
      </div>
      <div className="  col-span-2">
        <p className="text-sm text-blue/[0.5]">{t('driver.dl_no')}</p>
        <div>
          <p className="text-sm capitalize">{driver.dlNumber}</p>
        </div>
      </div>
      <div className="  col-span-2">
        <p className="text-sm text-blue/[0.5]">{t('driver.license_expiry')}</p>
        <div
          className="transititext-primary  transition duration-150 ease-in-out"
          // data-tooltip-id="tooltip"
          // data-tooltip-content={moment(driver?.dlExpiry).format("Do MMM YYYY")}
        >
          <p className="text-sm">
            {driver ? moment(driver?.dlExpiry).format('Do MMM YYYY') : 'N/A'}
          </p>
        </div>
      </div>
      <div className="  col-span-2">
        <p className="text-sm text-blue/[0.5]">{t('orders_page.created_at')}</p>
        <div
          className="transititext-primary  transition duration-150 ease-in-out"
        >
          <p className="text-sm">
            {driver ? moment(driver?.createdAt).format('Do MMM YYYY') : 'N/A'}
          </p>
        </div>
      </div>
      {/* <div className="col-span-1"></div> */}
      <div className="col-span-1">
        <Button
          variant="light"
          size="sm"
          color="danger"
          onClick={() => onAction(driver)}
          isIconOnly
          startContent={
            <img
              src="/assets/icons/chevon_right_red.svg"
              alt="lock"
              className={`inline ltr:float-right rtl:float-left rtl:rotate-180 cursor-pointer ${
                i18n.language === "ar" ? "scale-x-[-1]" : "scale-x-1"
              }`}
            />
          }
          className='rounded-full shadow-lg'
        />
      </div>
    </div>
  );
}
